<template>
  <div class="sonar-welcome-card">
    <SonarHero class="sonar-welcome-card__bg" />
    <SonarHeroMobile class="sonar-welcome-card__bg-mobile" />
    <div class="sonar-welcome-card__info-wrapper">
      <div class="sonar-welcome-card__description">
        Where do your skills stack up?
      </div>
      <section class="sonar-welcome-card__content">
        Skill Sonar detects your knowledge and skills strengths, and areas of
        improvement, through short hands-on assessments providing the insight
        you need to develop a targeted learning strategy.
      </section>
      <button
        class="btn btn--primary sonar-welcome-card__cta"
        @click="goToAllAssessments()"
      >
        Choose an assessment
      </button>
    </div>
  </div>
</template>

<script>
import SonarHero from '@/sonar/assets/images/sonar_hero.svg'
import SonarHeroMobile from '@/sonar/assets/images/sonarhero_mobile.svg'

export default {
  name: 'SonarWelcomeCard',
  components: {
    SonarHero,
    SonarHeroMobile,
  },
  data() {
    return {
      navBar: document.querySelector('.navbar'),
      mobileNavBar: document.querySelector('.mobile-navbar'),
    }
  },
  methods: {
    goToAllAssessments() {
      const navHeight =
        this.navBar?.offsetHeight || this.mobileNavBar?.offsetHeight
      this.$scrollTo(`#all-assessments`, 1000, {
        container: 'body',
        offset: -navHeight - 10,
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.sonar-welcome-card {
  color: var(--white);
  margin-bottom: 60px;
  @include mobile {
    margin-bottom: 120px;
  }
  &__cta {
    display: none;
    @include mobile {
      display: block;
    }
  }
  &__info-wrapper {
    margin-top: 137px;
    max-width: 565px;
    @include tablet {
      margin-top: 0;
    }
  }
  &__title-wrapper {
    display: flex;
    justify-content: space-between;
    gap: 10px;
    margin-bottom: 20px;
  }
  &__title {
    color: var(--white);
    margin: 0;
    font-size: rem(32);
    line-height: rem(38);
    font-weight: 600;
  }
  &__description {
    font-size: rem(18);
    line-height: rem(24);
    margin-bottom: 10px;
    font-weight: 700;

    @include tablet {
      font-size: rem(20);
      line-height: rem(26);
    }
  }

  &__content {
    display: flex;
    font-size: rem(16);
    color: var(--light-blue-gray);
    margin-bottom: 40px;
  }
  &__bg {
    position: absolute;
    right: 0;
    top: 0;
    z-index: -1;
    display: none;
    @include mobile {
      display: block;
      top: -425px;
      max-width: 100%;
    }
    &-mobile {
      position: absolute;
      left: -0;
      top: 66px;
      z-index: -1;
      display: block;
      width: 100%;
      @include mobile {
        display: none;
      }
    }
  }
}
</style>
